import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import { LoadingButton } from "@material-ui/lab";
import PropTypes from "prop-types";
import AnalyticsWidgetSummary from "src/components/estadisticas/app-analytics-widget-summary";
import nuevoClientes from "@iconify/icons-ant-design/user-add-outlined";
import promedioPlanesIcono from "@iconify/icons-ant-design/solution-outline";
import promedioPagoPlanes from "@iconify/icons-ant-design/file-done-outlined";
import promedioPagoTareas from "@iconify/icons-ant-design/check-square-outlined";
import AppWidgetIcon from "src/components/estadisticas/app-widgets-icon";
import AppTopPlan from "src/components/estadisticas/app-top-plan";
import AppContribuyenteSegunPlanes from "src/components/estadisticas/app-contribuyente-segun-planes";
import { useCallback, useMemo, useState } from "react";
import ModalDetalleEstadisticasFacturas from "../modalDetalleEstadisticasFacturas";
import { facturasApi } from "src/services/facturasApi";
import ModalDetalleDivisionClientes from "../modalDetalleDivisionClientes";
import { clientesApi } from "src/services/clientesApi";
import dayjs from "dayjs";
import { formatearFecha } from "src/utils/formatTime";
import ModalInformacionNuevosClientes from "../modalInformacionNuevosClientes";

const DIVISION_TIPOS = {
  "clientes planes": {
    tipo: "planes",
    titulo: "Clientes con solo planes",
  },
  "clientes tareas especiales": {
    tipo: "especiales",
    titulo: "Clientes con solo tareas especiales",
  },
};

const TIPOS_TARJETA = {
  planes: {
    tipoFactura: "plan",
    titulo: "Detalle facturas planes clientes",
  },
  tareas: {
    tipoFactura: "tarea",
    titulo: "Detalle facturas tareas clientes",
  },
};

const ModalDistribucionClientes = ({
  isOpen,
  setOpen,
  title,
  cantidadPromedioPlanes,
  divisionClientes,
  planesMasCotizados,
  contribuyentesPlanes,
  promedioFacturaClientes,
  cargandoContribuyentesPlanes,
  cargandoDivisionClientes,
  cargandoPlanesMasCotizados,
  cargandoCantidadPromedioPlanes,
  cargandoPromedioFacturaClientes,
  filtros,
}) => {
  const [
    abrirModalDetalleEstadisticasFacturas,
    setAbrirModalDetalleEstadisticasFacturas,
  ] = useState(false);
  const [
    abrirModalDetalleDivisionClientes,
    setAbrirModalDetalleDivisionClientes,
  ] = useState(false);
  const [
    abrirModalInformacionNuevosClientes,
    setAbrirModalInformacionNuevosClientes,
  ] = useState(false);

  const [titulo, setTitulo] = useState("");
  const [tituloDivisionClientes, setTituloDivisionClientes] = useState("");
  const [tituloInformacionNuevosClientes, setTituloInformacionNuevosClientes] =
    useState("");

  const {
    data: cantidadNuevosClientesPorMes,
    isFetching: obteniendoCantidadNuevosClientesPorMes,
  } = clientesApi.useGetNuevosClientesIngresadosPorRangoQuery({
    rut: filtros.rut,
    fechaInicio: filtros.fechaInicio,
    fechaFin: filtros.fechaFin,
    sucursales: filtros.sucursales,
    tipo: "cantidad",
  });

  const [
    obtenerInformacionClientesNuevos,
    {
      data: informacionClientesNuevosPorMes,
      isFetching: obteniendoInformacionClientesNuevosPorMes,
    },
  ] = clientesApi.useLazyGetNuevosClientesIngresadosPorRangoQuery();

  const [obtenerFacturas, { data: facturas, isFetching: obteniendoFacturas }] =
    facturasApi.useLazyObtenerClientesMayorCantidadFacturasPagadasQuery();
  const [
    obtenerDetalleDivisionClientes,
    {
      data: detalleDivisionClientes,
      isFetching: obteniendoDetalleDivisionClientes,
    },
  ] = clientesApi.useLazyObtenerDetalleDivisionClientesQuery();

  const handleClose = () => {
    setOpen(false);
  };

  const manejarClicTarjeta = useCallback(
    (tipo) => {
      const tipoConfig = TIPOS_TARJETA[tipo.toLowerCase()];

      if (!tipoConfig) {
        throw new Error("Tipo de tarjeta no válida");
      }

      const body = {
        rut: filtros.rut,
        tipo: tipoConfig.tipoFactura,
        sucursales: filtros.sucursales,
        fechaInicio: filtros.fechaInicio,
        fechaFin: filtros.fechaFin,
      };

      obtenerFacturas(body);
      setTitulo(tipoConfig.titulo);
      setAbrirModalDetalleEstadisticasFacturas(true);
    },
    [
      filtros.fechaFin,
      filtros.fechaInicio,
      filtros.rut,
      filtros.sucursales,
      obtenerFacturas,
    ],
  );

  const manejarClicTarjetaNuevosClientes = useCallback(() => {
    const body = {
      rut: filtros.rut,
      fechaInicio: filtros.fechaInicio,
      fechaFin: filtros.fechaFin,
      sucursales: filtros.sucursales,
      tipo: "informacion",
    };

    const fechaInicio = dayjs(filtros.fechaInicio, "YYYY/MM");
    const fechaFin = dayjs(filtros.fechaFin, "YYYY/MM");

    let tituloModal;
    if (fechaInicio.isSame(fechaFin, "month")) {
      const fechaFormateada = formatearFecha(
        filtros.fechaInicio,
        "MMMM [del] YYYY",
      );
      tituloModal = `Clientes ingresados en el mes de ${fechaFormateada}`;
    } else {
      const inicioFormateado = formatearFecha(filtros.fechaInicio, "MMMM YYYY");
      const finFormateado = formatearFecha(filtros.fechaFin, "MMMM YYYY");
      tituloModal = `Clientes ingresados entre ${inicioFormateado} y ${finFormateado}`;
    }
    setTituloInformacionNuevosClientes(tituloModal);
    obtenerInformacionClientesNuevos(body);
    setAbrirModalInformacionNuevosClientes(true);
  }, [
    filtros.fechaFin,
    filtros.fechaInicio,
    filtros.rut,
    filtros.sucursales,
    obtenerInformacionClientesNuevos,
  ]);

  const manejarClicDivisionClientes = useCallback(
    (label) => {
      const tipoConfig = DIVISION_TIPOS[label.toLowerCase()];

      if (!tipoConfig) {
        throw new Error(`Tipo ${label} no permitido`);
      }

      const body = {
        rut: filtros.rut,
        tipo: tipoConfig.tipo,
        sucursales: filtros.sucursales,
        fechaInicio: filtros.fechaInicio,
        fechaFin: filtros.fechaFin,
      };

      obtenerDetalleDivisionClientes(body);
      setTituloDivisionClientes(tipoConfig.titulo);
      setAbrirModalDetalleDivisionClientes(true);
    },
    [
      filtros.fechaFin,
      filtros.fechaInicio,
      filtros.rut,
      filtros.sucursales,
      obtenerDetalleDivisionClientes,
    ],
  );

  const tituloTarjetaNuevosClientes = useMemo(() => {
    const fechaInicio = dayjs(filtros.fechaInicio, "YYYY/MM");
    const fechaFin = dayjs(filtros.fechaFin, "YYYY/MM");

    if (fechaInicio.isSame(fechaFin, "month")) {
      const fechaFormateada = formatearFecha(
        filtros.fechaInicio,
        "MMMM [de] YYYY",
      );
      return `Clientes ingresados en ${fechaFormateada}`;
    } else {
      // Si es rango, mostrar período
      const inicioFormateado = formatearFecha(filtros.fechaInicio, "MMMM YYYY");
      const finFormateado = formatearFecha(filtros.fechaFin, "MMMM YYYY");
      return `Clientes ingresados entre ${inicioFormateado} y ${finFormateado}`;
    }
  }, [filtros.fechaInicio, filtros.fechaFin]);

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="dialog-modal-estadisticas-facturacion"
        id="dialog-modal-estadisticas-facturacion"
        fullWidth
        maxWidth="xl"
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={12}>
            <DialogTitle htmlFor="dialog-modal-estadisticas-facturacion">
              {title}
            </DialogTitle>
          </Grid>
        </Grid>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item sm={12} md={8} lg={8}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3} lg={3}>
                  <AnalyticsWidgetSummary
                    title={tituloTarjetaNuevosClientes}
                    total={
                      !obteniendoCantidadNuevosClientesPorMes &&
                      cantidadNuevosClientesPorMes
                        ? cantidadNuevosClientesPorMes
                        : 0
                    }
                    color="success"
                    loading={obteniendoCantidadNuevosClientesPorMes}
                    icon={nuevoClientes}
                    cursor="pointer"
                    onClick={() => manejarClicTarjetaNuevosClientes()}
                  />
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <AnalyticsWidgetSummary
                    title="Promedio de planes contratados por cliente"
                    total={
                      !cargandoCantidadPromedioPlanes && cantidadPromedioPlanes
                        ? cantidadPromedioPlanes
                        : 0
                    }
                    color="info"
                    loading={cargandoCantidadPromedioPlanes}
                    icon={promedioPlanesIcono}
                  />
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <AnalyticsWidgetSummary
                    title="Promedio de facturas de planes pagadas por cliente"
                    total={
                      !cargandoPromedioFacturaClientes &&
                      promedioFacturaClientes
                        ? promedioFacturaClientes.planes
                        : 0
                    }
                    loading={cargandoPromedioFacturaClientes}
                    color="warning"
                    type="dinero"
                    icon={promedioPagoPlanes}
                    cursor="pointer"
                    onClick={() => manejarClicTarjeta("planes")}
                  />
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <AnalyticsWidgetSummary
                    title="Promedio de facturas de tareas pagadas por cliente"
                    total={
                      !cargandoPromedioFacturaClientes &&
                      promedioFacturaClientes
                        ? promedioFacturaClientes.tareas
                        : 0
                    }
                    loading={cargandoPromedioFacturaClientes}
                    color="secondary"
                    type="dinero"
                    icon={promedioPagoTareas}
                    cursor="pointer"
                    onClick={() => manejarClicTarjeta("tareas")}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <AppWidgetIcon
                    loading={cargandoDivisionClientes}
                    onClick={manejarClicDivisionClientes}
                    series={[
                      {
                        label: "Clientes planes",
                        total:
                          !cargandoDivisionClientes && divisionClientes
                            ? divisionClientes.clientesPlan
                            : 0,
                        clic: true,
                        imagen: "/assets/icons/glass/clientes_planes.svg",
                      },
                      {
                        label: "Clientes tareas especiales",
                        total:
                          !cargandoDivisionClientes && divisionClientes
                            ? divisionClientes.clientesTareasEspeciales
                            : 0,
                        clic: true,
                        imagen:
                          "/assets/icons/glass/clientes_tareas_especiales.svg",
                      },
                    ]}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={12} md={4} lg={4} sx={{ width: "100%" }}>
              <AppTopPlan
                list={
                  !cargandoPlanesMasCotizados && planesMasCotizados
                    ? planesMasCotizados
                    : []
                }
                loading={cargandoPlanesMasCotizados}
                title="Planes más cotizados"
                sx={{ height: 1 }}
              />
            </Grid>
            <Grid item sm={12} md={12} lg={12}>
              <AppContribuyenteSegunPlanes
                loading={cargandoContribuyentesPlanes}
                rows={
                  !cargandoContribuyentesPlanes && contribuyentesPlanes
                    ? contribuyentesPlanes
                    : []
                }
                title="Clientes según planes"
                subheader="Se muestra qué clientes tienen contratado un determinado plan"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <LoadingButton onClick={handleClose} color="error">
            Cerrar
          </LoadingButton>
        </DialogActions>
      </Dialog>
      {abrirModalDetalleEstadisticasFacturas && (
        <ModalDetalleEstadisticasFacturas
          isOpen={abrirModalDetalleEstadisticasFacturas}
          setOpen={setAbrirModalDetalleEstadisticasFacturas}
          title={titulo}
          facturas={facturas}
          cargandoFacturas={obteniendoFacturas}
        />
      )}
      {abrirModalDetalleDivisionClientes && (
        <ModalDetalleDivisionClientes
          isOpen={abrirModalDetalleDivisionClientes}
          setOpen={setAbrirModalDetalleDivisionClientes}
          title={tituloDivisionClientes}
          cargandoDetalleDivisionClientes={obteniendoDetalleDivisionClientes}
          detalleDivisionclientes={detalleDivisionClientes}
        />
      )}
      {abrirModalInformacionNuevosClientes && (
        <ModalInformacionNuevosClientes
          isOpen={abrirModalInformacionNuevosClientes}
          setOpen={setAbrirModalInformacionNuevosClientes}
          title={tituloInformacionNuevosClientes}
          cargandoNuevosClientes={obteniendoInformacionClientesNuevosPorMes}
          nuevosClientes={informacionClientesNuevosPorMes}
        />
      )}
    </>
  );
};

ModalDistribucionClientes.propTypes = {
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  setOpen: PropTypes.func,
  cantidadPromedioPlanes: PropTypes.number,
  divisionClientes: PropTypes.object,
  promedioFacturaClientes: PropTypes.object,
  planesMasCotizados: PropTypes.arrayOf(
    PropTypes.shape({
      nombre: PropTypes.string.isRequired,
      cantidad: PropTypes.number.isRequired,
    }),
  ),
  contribuyentesPlanes: PropTypes.array,
  cargandoContribuyentesPlanes: PropTypes.bool,
  cargandoPlanesMasCotizados: PropTypes.bool,
  cargandoPromedioFacturaClientes: PropTypes.bool,
  cargandoDivisionClientes: PropTypes.bool,
  cargandoCantidadPromedioPlanes: PropTypes.bool,
  filtros: PropTypes.shape({
    rut: PropTypes.string.isRequired,
    sucursales: PropTypes.array.isRequired,
    fechaInicio: PropTypes.string.isRequired,
    fechaFin: PropTypes.string.isRequired,
  }).isRequired,
};

export default ModalDistribucionClientes;
